export default __webpack_public_path__ + "static/media/contact.73789c94.svg";